import readXlsxFile, {readSheetNames} from 'read-excel-file'
import {useRef} from 'react'
import uuid from 'react-uuid'
import uploadIcon from '../../../../../_metronic/images/uploadIcon.svg'
import {IFormattedData, AvailableLanguages} from './ParseExcelInterface'
import {alert} from '../../../../../utils/helper'

import withReactContent from 'sweetalert2-react-content'
import Swal from 'sweetalert2'

import SwalThinkingImage from '../../../../../_metronic/images/swal_thinking_face.svg'
import {DownloadTemplate} from '../../../../sharedComponent/DownloadTemplate/DownloadTemplate'
import {GLOBAL_CONSTANTS} from '../../../../../utils/GlobalConstants'
const MySwal = withReactContent(Swal)

export default function ParseExcel({
  payload,
  isSolarProduct,
  setPayload,
  languagesSelected,
  availableLanguages,
  setSelectedLanguage,
  setQuestions,
  setDualQuestions,
  setElectricQuestions,
  setGasQuestions,
  setSolorQuestions,
}: any) {
  const file: any = useRef()
  const schema = {
    'QUESTION': {
      prop: 'description',
      type: String,
      required: true,
    },
    'ANSWER TYPE': {
      prop: 'questionType',
      type: String,
      required: true,
      oneOf: ['YESNO', 'DTMF', 'BOTH_OPTION', 'SPEECH_ONLY',"VOICE_RESPONSE"],
    },
    'CONTINUE FOR NO': {
      prop: 'continueCall',
      type: String,
      required: true,
      oneOf: ['YES', 'NO'],
    },
    'QUESTION TYPE': {
      prop: 'scriptType',
      type: String,
      required: true,
      oneOf: [
        GLOBAL_CONSTANTS.scriptType.electric,
        GLOBAL_CONSTANTS.scriptType.gas,
        GLOBAL_CONSTANTS.scriptType.dual,
        GLOBAL_CONSTANTS.scriptType.solar,
      ],
    },
  }
  const handleInputChange = (e: any) => {
    console.log(languagesSelected)
    readSheetNames(file.current.files[0]).then((sheetNames: any) => {
      // sheetNames === ['Sheet1', 'Sheet2']
      if (
        (sheetNames.length === 2 &&
          ((sheetNames[0] === 'English' && sheetNames[1] === 'Spanish') ||
            (sheetNames[0] === 'Spanish' && sheetNames[1] === 'English'))) ||
        (sheetNames.length === 1 && (sheetNames[0] === 'English' || sheetNames[0] === 'Spanish'))
      ) {
        Promise.all(
          sheetNames.map(async (sheet: any) => {
            return await readXlsxFile(file.current.files[0], {schema: schema, sheet: sheet}).then(
              (data: any) => data
            )
          })
        )
          .then((parsedData: any) =>
            parsedData.map((data: any, index: any) => {
              console.log('parsed data')
              return {languageName: sheetNames[index], ...data}
            })
          )
          .then((formattedData: Array<IFormattedData>) => {
            console.log('formatted Data', formattedData)
            const hasEmptyRows = formattedData.filter((data: any) => data.rows.length === 0)
            const hasError =
              formattedData.map((data: IFormattedData) => data.errors).flatMap((err: any) => err)
                .length !== 0
            if (!hasError) {
              if (hasEmptyRows.length !== 0) {
                MySwal.fire({
                  title: 'Are you sure?',
                  text: `${hasEmptyRows[0].languageName} excel sheet is empty`,
                  iconHtml: `<img src=${SwalThinkingImage}>`,
                  customClass: {
                    icon: 'no-border',
                  },
                  showCancelButton: true,
                  confirmButtonText: 'Yes, proceed it',
                  confirmButtonColor: '#3E97FF',
                  cancelButtonText: 'No, cancel !',
                  cancelButtonColor: 'rgb(39 37 37 / 52%)',
                  reverseButtons: true,
                }).then(function (result) {
                  if (result.value) {
                    let formattedAvailableLanguages: AvailableLanguages = {}
                    availableLanguages.forEach(
                      (lang: any) =>
                        (formattedAvailableLanguages = {
                          ...formattedAvailableLanguages,
                          [lang.label]: lang.value,
                        })
                    )
                    setPayload((prev: any) => {
                      return {
                        ...prev,
                        scriptQuestions: formattedData.map(({languageName, rows}: any) => {
                          return {
                            languageId: formattedAvailableLanguages[languageName],
                            questions: rows.map((question: any) => {
                              return {
                                ...question,
                                id: `${uuid()}`,
                                continueCall: question.continueCall === 'YES' ? true : false,
                                scriptLangId: formattedAvailableLanguages[languageName],
                              }
                            }),
                          }
                        }),
                      }
                    })
                    const selectedLanguagesFromSheet = sheetNames.map((sheetName: any) => {
                      if (!!formattedAvailableLanguages[sheetName]) {
                        return {
                          label: sheetName,
                          value: formattedAvailableLanguages[sheetName],
                        }
                      }
                    })
                    setSelectedLanguage(selectedLanguagesFromSheet)
                    console.log(
                      'selectedlanguages',
                      selectedLanguagesFromSheet,
                      formattedAvailableLanguages
                    )
                    //to add language ids array for api call
                    setPayload((prevpayload: any) => {
                      return {
                        ...prevpayload,
                        languageIds: selectedLanguagesFromSheet.map(({value}: any) => value),
                      }
                    })
                    return
                  } else {
                    setQuestions([])
                    setPayload((prev: any) => ({
                      ...prev,
                      scriptQuestions: prev.scriptQuestions.map((question: any) => ({
                        ...question,
                        questions: [],
                      })),
                    }))
                    console.log(payload)
                    file.current.value = null
                  }
                })
              } else {
                let formattedAvailableLanguages: AvailableLanguages = {}
                availableLanguages.forEach(
                  (lang: any) =>
                    (formattedAvailableLanguages = {
                      ...formattedAvailableLanguages,
                      [lang.label]: lang.value,
                    })
                )
                let formattedQuestions = formattedData.map(({languageName, rows}: any) => {
                  return {
                    languageId: formattedAvailableLanguages[languageName],
                    questions: rows.map((question: any) => {
                      return {
                        ...question,
                        id: `${uuid()}`,
                        continueCall: question.continueCall === 'YES' ? true : false,
                        scriptLangId: formattedAvailableLanguages[languageName],
                      }
                    }),
                  }
                })
                setSolorQuestions(
                  formattedQuestions[0]?.questions.filter(
                    (question: any) => question.scriptType === GLOBAL_CONSTANTS.scriptType.solar
                  )
                )

                setDualQuestions(
                  formattedQuestions[0]?.questions.filter(
                    (question: any) => question.scriptType === GLOBAL_CONSTANTS.scriptType.dual
                  )
                )
                setElectricQuestions(
                  formattedQuestions[0]?.questions.filter(
                    (question: any) => question.scriptType === GLOBAL_CONSTANTS.scriptType.electric
                  )
                )
                setGasQuestions(
                  formattedQuestions[0]?.questions.filter(
                    (question: any) => question.scriptType === GLOBAL_CONSTANTS.scriptType.gas
                  )
                )
                setPayload((prev: any) => {
                  const updatedScriptQuestions = [...(prev.scriptQuestions || [])]
                  formattedQuestions.forEach((newItem) => {
                    const existingIndex = updatedScriptQuestions.findIndex(
                      (item) => item.languageId === newItem.languageId
                    )

                    if (existingIndex !== -1) {
                      updatedScriptQuestions[existingIndex].questions = [
                        ...updatedScriptQuestions[existingIndex].questions,
                        ...newItem.questions,
                      ]
                    } else {
                      updatedScriptQuestions.push(newItem)
                    }
                  })

                  return {
                    ...prev,
                    scriptQuestions: updatedScriptQuestions,
                  }
                })
                let selectedLanguagesFromSheet = sheetNames.map((sheetName: any) => {
                  if (!!formattedAvailableLanguages[sheetName]) {
                    return {
                      label: sheetName,
                      value: formattedAvailableLanguages[sheetName],
                    }
                  }
                })
                setSelectedLanguage(selectedLanguagesFromSheet)

                //to add language ids array for api call
                setPayload((prevpayload: any) => {
                  return {
                    ...prevpayload,
                    languageIds: selectedLanguagesFromSheet.map(({value}: any) => value),
                  }
                })
              }
            } else {
              alert('Please Upload valid data', 'error')
            }
          })
          .finally(() => {
            e.target.value = null
          })
      } else {
        alert('Please Upload valid data', 'error')
      }
    })
  }
  return (
    <>
      <button
        className='btn btn-active-light-primary btn-light-primary fs-6 px-5 py-3 d-flex align-items-center'
        onClick={() => file.current.click()}
      >
        <img src={uploadIcon} alt='' className='svg-icon svg-icon-1 me-0' />
        <div className='ms-1 fs-6'>Import</div>
      </button>

      <input
        ref={file}
        type='file'
        style={{display: 'none'}}
        accept='.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel'
        onChange={(e) => handleInputChange(e)}
        id='input'
      />

      <DownloadTemplate
        href={
          isSolarProduct
            ? process.env.REACT_APP_SOLAR_SCRIPT_TEMPLATE_DOWNLOAD
            : process.env.REACT_APP_SCRIPT_TEMPLATE_DOWNLOAD
        }
        text='Download Template'
      />
    </>
  )
}
